module.exports = __webpack_public_path__ + "static/img/badge_hc.01cd4f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/badges/badge_hc.svg
// module id = 2367
// module chunks = 0